module.exports = __webpack_public_path__ + "img/support-pos-favourite.361b80e0.svg";